import {
    buildViewerBinaryCacheKeyFromType,
    createBinaryBlob,
} from '../../helpers/viewerBinaryCache';

export function getSceneAssetStatus(geometryStatus, textureStatus) {
    if (geometryStatus === 'failed') {
        return 'failed';
    }

    if (geometryStatus !== 'ready') {
        return 'loading';
    }

    if (textureStatus === 'loading') {
        return 'loading';
    }

    return 'ready';
}

export function buildInitialSceneAssetState(model) {
    const geometryStatus = model.geometryUrl ? 'loading' : 'failed';
    const textureStatus = model.textureUrl ? 'loading' : 'idle';

    return {
        descriptorKey: model.descriptorKey,
        error: null,
        geometryBuffer: null,
        geometryStatus,
        model,
        status: getSceneAssetStatus(geometryStatus, textureStatus),
        textureBlob: null,
        textureStatus,
    };
}

export function patchSceneAssetState(currentState, patch) {
    const nextState = {
        ...currentState,
        ...patch,
    };

    nextState.status = getSceneAssetStatus(nextState.geometryStatus, nextState.textureStatus);

    return nextState;
}

export function createTextureBlobFromResource(resource) {
    return createBinaryBlob(resource, 'image/jpeg');
}

function buildSceneAssetResourcePlanEntry(resourceType, type, url) {
    if (!url) {
        return null;
    }

    return {
        cacheKey: buildViewerBinaryCacheKeyFromType(type, url),
        resourceType,
        type,
        url,
    };
}

export function getSceneAssetResourcePlan(model) {
    return {
        descriptorKey: model.descriptorKey,
        geometry: buildSceneAssetResourcePlanEntry(
            'geometry',
            model.format === 'ply' ? 'geometry-ply' : 'geometry-stl',
            model.geometryUrl,
        ),
        texture: buildSceneAssetResourcePlanEntry(
            'texture',
            'texture',
            model.textureUrl,
        ),
    };
}
